export const GET_ALL_ATTACHMENTS_SUCCESS = "GET_ALL_ATTACHMENTS_SUCCESS";
export const GET_ALL_ATTACHMENTS_LOADING = "GET_ALL_ATTACHMENTS_LOADING";
export const GET_ALL_ATTACHMENTS_FAILURE = "GET_ALL_ATTACHMENTS_FAILURE";
